import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'shards-react';
import VChart from './VChart';

const chartColors = [
  '#8445f7',
  '#007bff',
  '#17c671',
  '#fb7906',
  '#ff4169',
  '#00b8d8',
  '#818ea3',
  '#c4183c',
  '#ffd500',
  '#5a6169',
];

const pieChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: 'right',
    labels: {
      padding: 7,
      boxWidth: 20,
    },
  },
};

const SubscriptionByPlan = ({ subscriptions, title }) => {
  const {
    datasets,
    labels,
    totals,
  } = useMemo(() => {
    const sortedSubscriptions = [...(subscriptions || [])]
      .filter(item => item.total > 0)
      .sort((first, second) => second.total - first.total);
    const statusTotals = sortedSubscriptions.reduce((result, item) => ({
      current: result.current + (item.current || 0),
      expiredActive: result.expiredActive + (item.expiredActive || 0),
      total: result.total + (item.total || 0),
    }), {
      current: 0,
      expiredActive: 0,
      total: 0,
    });

    return {
      labels: sortedSubscriptions.map(item => item.label),
      datasets: sortedSubscriptions.length > 0
        ? [{
          label: `Subscriptions (${statusTotals.total})`,
          data: sortedSubscriptions.map(item => item.total || 0),
          backgroundColor: sortedSubscriptions.map(
            (item, index) => chartColors[index % chartColors.length],
          ),
        }]
        : [],
      totals: statusTotals,
    };
  }, [subscriptions]);

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
        {labels.length > 0 && (
          <small className="text-muted">
            {`${totals.current || 0} current \u2022 ${totals.expiredActive || 0} marked active but expired`}
          </small>
        )}
      </CardHeader>
      <CardBody className="py-3">
        {labels.length > 0
          ? (
            <div className="w-100" style={{ height: '285px', position: 'relative' }}>
              <VChart
                labels={labels}
                datasets={datasets}
                type="pie"
                height="285"
                style={{ height: '100%', width: '100%' }}
                chartOptions={pieChartOptions}
              />
            </div>
          )
          : <div className="text-center text-muted w-100 p-4">No subscription records</div>}
      </CardBody>
    </Card>
  );
};

SubscriptionByPlan.propTypes = {
  subscriptions: PropTypes.array,
  title: PropTypes.string,
};

SubscriptionByPlan.defaultProps = {
  subscriptions: [],
  title: 'Subscriptions by Plan',
};

export default SubscriptionByPlan;
